import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { pick } from 'ramda';
import * as Yup from 'yup';
import { composeSchema, isEmail } from 'utils/validations';

import FmcForm from 'components/FmcForm';
import EmailVerificationView from './EmailVerificationView';
import useNavigationHelpers from 'hooks/useNavigationHelpers';
import useTranslate from 'hooks/useTranslate';
import {
  mergeApplication,
  selectCreditApplication,
} from 'state/creditApplication';

export interface FormValues {
  emailAddress: string | null;
}

type PropTypes = RouteComponentProps;

const EmailVerification: React.FC<PropTypes> = () => {
  const { push } = useNavigationHelpers();
  const t = useTranslate();
  const dispatch = useDispatch();
  const creditApplication = useSelector(selectCreditApplication);
  const schema = useMemo(
    () =>
      Yup.object().shape({
        emailAddress: composeSchema(
          Yup.string().label(t('formLabel.emailAddress')),
          Yup.string()
            .required()
            .nullable(),
          isEmail,
        ),
      }),
    [t],
  );

  const onSubmit = useCallback(
    async (rawValues: FormValues) => {
      const values = schema.cast(rawValues);
      dispatch(
        mergeApplication({
          emailAddress: values.emailAddress,
        }),
      );
      push('/unified/mobile-verification');
    },
    [schema, dispatch, push],
  );

  const initialValues: FormValues = pick(
    ['emailAddress'],
    creditApplication,
  ) as FormValues;

  return (
    <FmcForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={schema}
    >
      {formProps => <EmailVerificationView {...formProps} />}
    </FmcForm>
  );
};

export default EmailVerification;
